import { render, staticRenderFns } from "./LastSale.vue?vue&type=template&id=eef8d36e&scoped=true&"
import script from "./LastSale.vue?vue&type=script&lang=js&"
export * from "./LastSale.vue?vue&type=script&lang=js&"
import style0 from "./LastSale.vue?vue&type=style&index=0&id=eef8d36e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef8d36e",
  null
  
)

export default component.exports